// @flow

import React from 'react';

import { FlinkPoolContextProvider } from '../../contexts/FlinkPoolContextProvider';
import { MonthlyInputsMetaDataContextProvider } from '../../contexts/MonthlyInputsMetaDataContextProvider';
import { FlinkPoolBreadcrumbs } from '../breadcrumbs/FlinkPoolBreadcrumbs';
import { ShowLoaderIfAnyQueryIsPending } from '../presentational/ShowLoaderIfAnyQueryIsPending';
import { UserContextProvider } from '../../contexts/UserContextProvider';
import { EstimateContextProvider } from '../../contexts/EstimateContextProvider';
import { AiAssistantEstimateContextBridge } from '../ai-assistant/AiAssistantEstimateContextBridge';

import { FlinkPoolTopLevelContainerForm } from './FlinkPoolTopLevelContainerForm';

export const FlinkPoolTopLevelContainer = () => {
  return (
    <>
      <ShowLoaderIfAnyQueryIsPending />
      <UserContextProvider>
        <EstimateContextProvider>
          <AiAssistantEstimateContextBridge />
          <MonthlyInputsMetaDataContextProvider>
            <FlinkPoolContextProvider>
              <FlinkPoolBreadcrumbs />
              <FlinkPoolTopLevelContainerForm />
            </FlinkPoolContextProvider>
          </MonthlyInputsMetaDataContextProvider>
        </EstimateContextProvider>
      </UserContextProvider>
    </>
  );
};
